<template>
  <store-modal
    name="PayoutModalTransfer"
    class="payout-modal-transfer"
    :loading="withdrawalCreating"
  >
    <template #header>
      <div class="payout-modal-transfer__header">
        <div class="title">
          <template v-if="!withdrawalCreated">
            {{ title }}
          </template>
          <template v-else>
            <svg
              v-if="!_withdrawalError"
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
            >
              <rect width="60" height="60" rx="10" fill="#5BB24D"/>
              <path d="M36.3102 23.5605C36.9326 22.9382 37.9417 22.9382 38.5641 23.5605C39.1789 24.1753 39.1864 25.1674 38.5867 25.7914L30.1033 36.3957C30.0911 36.411 30.078 36.4256 30.0641 36.4395C29.4417 37.0619 28.4326 37.0619 27.8102 36.4395L22.1865 30.8158C21.5641 30.1934 21.5641 29.1842 22.1865 28.5618C22.8089 27.9395 23.818 27.9395 24.4404 28.5618L28.8892 33.0106L36.268 23.6082C36.2811 23.5915 36.2952 23.5756 36.3102 23.5605Z" fill="white"/>
            </svg>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="60"
              height="60"
              viewBox="0 0 60 60"
              fill="none"
            >
              <rect width="60" height="60" rx="10" fill="#B24D4D"/>
              <path d="M24.8098 18.2197C24.9504 18.079 25.1412 18 25.3401 18H34.6599C34.8588 18 35.0496 18.079 35.1902 18.2197L41.7803 24.8098C41.921 24.9504 42 25.1412 42 25.3401V34.6599C42 34.8588 41.921 35.0496 41.7803 35.1902L35.1902 41.7803C35.0496 41.921 34.8588 42 34.6599 42H25.3401C25.1412 42 24.9504 41.921 24.8098 41.7803L18.2197 35.1902C18.079 35.0496 18 34.8588 18 34.6599V25.3401C18 25.1412 18.079 24.9504 18.2197 24.8098L24.8098 18.2197ZM25.6508 19.5L19.5 25.6508V34.3492L25.6508 40.5H34.3492L40.5 34.3492V25.6508L34.3492 19.5H25.6508Z" fill="white"/>
              <path d="M24.9697 24.9697C25.2626 24.6768 25.7374 24.6768 26.0303 24.9697L30 28.9393L33.9697 24.9697C34.2626 24.6768 34.7374 24.6768 35.0303 24.9697C35.3232 25.2626 35.3232 25.7374 35.0303 26.0303L31.0607 30L35.0303 33.9697C35.3232 34.2626 35.3232 34.7374 35.0303 35.0303C34.7374 35.3232 34.2626 35.3232 33.9697 35.0303L30 31.0607L26.0303 35.0303C25.7374 35.3232 25.2626 35.3232 24.9697 35.0303C24.6768 34.7374 24.6768 34.2626 24.9697 33.9697L28.9393 30L24.9697 26.0303C24.6768 25.7374 24.6768 25.2626 24.9697 24.9697Z" fill="white"/>
            </svg>
          </template>
        </div>
      </div>
    </template>
    <template #body>
      <div class="payout-modal-transfer__body">
        <template v-if="withdrawalCreated">
          <div class="result__message-title">
            <template v-if="!_withdrawalError">
              {{ $t('payout-modal-transfer.output.title-success') }}
            </template>
            <template v-else>
              {{ $t('payout-modal-transfer.output.title-error') }}
            </template>
          </div>
          <div class="result__message-subtitle">
            <template v-if="!_withdrawalError">
              {{ $t('payout-modal-transfer.output.subtitle-success') }}
            </template>
            <template v-else>
              {{ $t('payout-modal-transfer.output.subtitle-error') }}
            </template>
          </div>
        </template>
        <template v-else-if="!withdrawalCreating && !withdrawalCreated">
          <div>
            <address-select
              v-model="setAddress"
              :list="addressesList"
              uniq-key="address"
            />
          </div>

          <template>
            <base-input
              v-model="amount"
              class="amount-input"
              placeholder="0"
              :label="$t('bridge.amount_to_input.label')"
              :min="minWithdrawal"
              :max="balanceAmount"
              has-action-btn
              @input="getFeeForTransferInputWrap"
              @action-btn-click="setMaxAmount"
            >
              <template #label-left>
                {{ $t('payout-modal-transfer.amount') }}
              </template>
            </base-input>

<!--        ниже приводится посчитанная информация о трансфере исходя из монеты/сети/количества -->
            <div
              v-if="showMinWithdrawalTip"
              class="title-special"
            >
              {{ $t('payout-modal-transfer.minimum_withdrawal') }} {{ minWithdrawal }}
              {{ balanceCurrencyId | getCurrencyTicker }}
            </div>
            <NewSpinner
              v-if="isFeeDebouncing || _feePending"
              class="fee-loader"
              size="small"
            />
            <div
              v-if="addressId && amount && (isFeeDebouncing !== null && !isFeeDebouncing) && !_feePending"
              class="info-container"
              :class="{ 'disabled': feeAvailableSeconds < 0 }"
            >
              <div class="info-container__row first">
                <div class="first-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.current_advance_balance') }}
                  </div>
                  <div class="value">
                    <span
                        :class="{danger: !balanceValid}">{{
                        accountBalance
                      }} {{ accountCurrencyId | getCurrencyTicker }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="info-container__row">
                <div class="first-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.service-commission-amount') }}
                  </div>
                  <div class="value">
                    {{ feeTariff }} USD
                  </div>
                </div>
                <div class="second-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.commission-source') }}
                  </div>
                  <div class="value">
                    {{ $t('payout-modal-transfer.advance_balance') }}
                  </div>
                </div>
              </div>
              <div class="info-container__row">
                <div class="first-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.blockchain-commission-amount') }}
                  </div>
                  <div class="value">
                    {{ feeNetwork }} USD
                  </div>
                </div>
                <div class="second-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.commission-source') }}
                  </div>
                  <div class="value">
                    {{ feeSourceTitle }}
                  </div>
                </div>
              </div>
              <div class="info-container__row">
                <div class="first-line">
                  <div class="label">
                    <b> {{ $t('payout-modal-transfer.receive') }} </b>
                  </div>
                  <div class="value">
                    <div style="font-weight: 600"> {{ amountToReceive }} {{ addressCurrency }}  <span class="grey"> ({{ amountToReceiveUSD }} USD) </span> </div>
                  </div>
                </div>
              </div>
              <div class="info-container__row">
                <div class="first-line">
                  <div class="label">
                    {{ $t('payout-modal-transfer.advance_balance_after') }}
                  </div>
                  <div class="value">
                    <span
                        :class="{danger: !balanceValid}">{{
                        accountBalanceAfter
                      }} {{ accountCurrencyId | getCurrencyTicker }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </template>
    <template #footer>
      <div
        class="payout-modal-transfer__footer"
        :class="{ 'withdrawal-created': withdrawalCreated }"
      >
        <template v-if="!withdrawalCreated">
          <base-button
            :label="$t('payout-modal-transfer.close')"
            type="secondary"
            @click="handleCancelCreate"
          />
          <base-button
            v-if="feeAvailableSeconds >= 0"
            :label="`${actionButtonTitle}${ feeAvailableSeconds > 0 && !actionButtonDisabled ? ` (${feeAvailableSeconds} sec)` : ''}`"
            type="primary"
            :disabled="actionButtonDisabled"
            @click="createWithdrawal"
          />
          <base-button
            v-else
            type="secondary"
            @click="fetchFee"
          >
            <template #label>
              <div class="update-btn-label">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M1.38666 6.79142C1.38666 9.92891 3.6173 12.0666 6.12286 12.5088C6.19102 12.5208 6.25618 12.5465 6.31463 12.5842C6.37308 12.6219 6.42366 12.671 6.46351 12.7287C6.50335 12.7863 6.53166 12.8514 6.54683 12.9203C6.562 12.9891 6.56372 13.0603 6.55191 13.1298C6.5401 13.1993 6.51498 13.2658 6.47798 13.3254C6.44098 13.385 6.39284 13.4366 6.33629 13.4772C6.27975 13.5178 6.2159 13.5467 6.14842 13.5622C6.08093 13.5776 6.01111 13.5794 5.94296 13.5673C3.00077 13.0479 0.333496 10.5185 0.333496 6.79142C0.333496 5.20721 1.03998 3.9621 1.86473 3.01591C2.45599 2.3377 3.13216 1.78626 3.67593 1.3647H2.0224C1.88837 1.3647 1.75983 1.3104 1.66506 1.21375C1.57028 1.11711 1.51704 0.986023 1.51704 0.849342C1.51704 0.712661 1.57028 0.581578 1.66506 0.484929C1.75983 0.388281 1.88837 0.333984 2.0224 0.333984H5.05454C5.18857 0.333984 5.31711 0.388281 5.41188 0.484929C5.50665 0.581578 5.5599 0.712661 5.5599 0.849342V3.94149C5.5599 4.07817 5.50665 4.20925 5.41188 4.3059C5.31711 4.40255 5.18857 4.45685 5.05454 4.45685C4.92051 4.45685 4.79197 4.40255 4.6972 4.3059C4.60242 4.20925 4.54918 4.07817 4.54918 3.94149V2.03879L4.54817 2.04085C3.97004 2.48406 3.26456 3.02724 2.65308 3.72916C1.93042 4.55786 1.38666 5.56074 1.38666 6.79142ZM12.6137 7.20989C12.6137 4.10537 10.4305 1.98107 7.95731 1.50694C7.88838 1.49501 7.82246 1.4692 7.76342 1.43102C7.70437 1.39284 7.65337 1.34305 7.61339 1.28456C7.57341 1.22606 7.54526 1.16003 7.53057 1.09032C7.51588 1.02061 7.51495 0.948619 7.52783 0.878539C7.54072 0.80846 7.56716 0.741698 7.60561 0.68215C7.64407 0.622603 7.69377 0.57146 7.75181 0.531708C7.80985 0.491955 7.87507 0.464388 7.94367 0.450615C8.01227 0.436841 8.08288 0.437137 8.15136 0.451486C11.0562 1.00807 13.6668 3.52302 13.6668 7.20989C13.6668 8.7941 12.9603 10.0382 12.1356 10.9854C11.5443 11.6636 10.8682 12.215 10.3244 12.6366H11.9779C12.112 12.6366 12.2405 12.6909 12.3353 12.7875C12.43 12.8842 12.4833 13.0153 12.4833 13.152C12.4833 13.2886 12.43 13.4197 12.3353 13.5164C12.2405 13.613 12.112 13.6673 11.9779 13.6673H8.94579C8.81176 13.6673 8.68322 13.613 8.58844 13.5164C8.49367 13.4197 8.44043 13.2886 8.44043 13.152V10.0598C8.44043 9.92313 8.49367 9.79205 8.58844 9.6954C8.68322 9.59875 8.81176 9.54446 8.94579 9.54446C9.07981 9.54446 9.20835 9.59875 9.30313 9.6954C9.3979 9.79205 9.45114 9.92313 9.45114 10.0598V11.9615H9.45316C10.0303 11.5162 10.7368 10.9741 11.3472 10.2711C12.0699 9.44345 12.6137 8.44159 12.6137 7.20989Z"
                    :fill="themeStatus === 'dark' ? 'white' : '#6750A4'"
                  />
                </svg>
                {{ $t('payout-modal-transfer.update') }}
              </div>
            </template>
          </base-button>
        </template>
        <template v-else>
          <base-button
            :label="$t('payout-modal-transfer.close')"
            type="primary"
            @click="handleCancelCreate"
          />
        </template>
      </div>
    </template>
  </store-modal>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

import AtSelect from 'at-ui/src/components/select';
import AtOption from 'at-ui/src/components/option';
import AtModal from 'at-ui/src/components/modal';
import CurrencyImg from "/public/components/elements/CurrencyImg";
import AtInput from 'at-ui/src/components/input';
import AtRadioGroup from 'at-ui/src/components/radio-group';
import AtRadio from 'at-ui/src/components/radio';
import LoadingSpinner from "/public/components/elements/LoadingSpinner";
import AtButton from 'at-ui/src/components/button';
import AtAlert from 'at-ui/src/components/alert';
import BaseModal from "../BaseModal";
import CopyString from "/public/components/elements/CopyString";
import moment from "moment";
import bchaddr from 'bchaddrjs';
import BigNumber from "bignumber.js";
import {FEE_TOKEN_SOURCE} from "../../../../common/constants/fee-token-source";
import _ from "lodash";
import Preloader from "../../common/preloader";


export default {
    name: 'PayoutModalTransfer',
    components: {
        AddressSelect: () => import(/* webpackChunkName: "/public/components/elements/advance-balances/AddressSelect" */ '/public/components/elements/advance-balances/AddressSelect'),
        BaseButton: () => import(/* webpackChunkName: "/public/components/common/uiKit/button/base/modals" */ '/public/components/common/uiKit/button/modals/bg-primary'),
        BaseInput: () => import(/* webpackChunkName: "/public/components/elements/advance-balances/input" */ '/public/components/elements/advance-balances/input'),
        StoreModal: () => import(/* webpackChunkName: "/public/components/modals/StoreModal" */ '/public/components/modals/StoreModal'),
        NewSpinner: () => import (/* webpackChunkName: "Spinner" */ "/public/components/common/uiKit/spinner/index.vue"),

        Preloader,
        BaseModal,
        AtSelect,
        AtOption,
        AtModal,
        CurrencyImg,
        AtInput,
        AtRadioGroup,
        AtRadio,
        LoadingSpinner,
        AtButton,
        AtAlert,
        CopyString,
    },
    balanceType: [
        {
            value: 'ADVANCE',
            label: 'payout-modal-transfer.advance',
        },
        {
            value: 'PAY_OUT',
            label: 'payout-modal-transfer.pay-out',
        },
    ],
    data() {
        return {
            accountId: '',
            addressesList: [],
            selectedAddress: undefined,
            addressTo: 'ADVANCE',
            address: '',
            tag: '',
            amount: '',
            isFeeDebouncing: null,
            time: new Date().toJSON(),
            timerId: 0
        };
    },
    computed: {
        ...mapState('app', {
            themeStatus: state => state.theme,
            currencies: state => state.currencies,
            payloadModal: state => state.modal.payload,
            addressWithdrawal: state => state.modal.payload?.addressId,
            depositMethodName: state => state.modal.payload?.depositMethodName,
            depositMethodLink: state => state.modal.payload?.depositMethodLink,
        }),
        ...mapState('accounts', [
            'accounts',
        ]),
        ...mapGetters('balances', [
            'balances',
        ]),
        ...mapGetters('app', [
            'isOpenModal',
        ]),
        ...mapState('payoutBalances', {
            _fee: state => state.fee,
            _feePending: state => state.fee.pending,
            _feeComplete: state => state.fee.complete,
            _feeCode: state => state.fee.code,
            _feeAmount: state => state.fee.amount,
            _feeUSD: state => state.fee.usdAmount,
            _feeUntil: state => state.fee.until,
            _feeCurrency: state => state.fee.currency,
            _feeToken: state => state.fee.token,
            _feeSource: state => state.fee.source,
            _tariffFee: state => state.fee.tariffFee,
            _tariffFeeUSD: state => state.fee.tariffFeeUSD,
            _networkFee: state => state.fee.networkFee,
            _networkFeeUSD: state => state.fee.networkFeeUSD,
            _withdrawalPending: state => state.deposit.pending,
            _withdrawalComplete: state => state.deposit.complete,
            _withdrawalError: state => state.deposit.error,
            _withdrawalId: state => state.deposit.id,
            _withdrawalStatus: state => state.deposit.status,
            _withdrawalTX: state => state.deposit.tx,
        }),
        addressId({ selectedAddress = {} }) {
          return selectedAddress.id
        },
        addressFrom({ depositMethodName }) {
          switch (depositMethodName) {
            case 'internalPayInBalance':
              return 'PAY_IN';
            case 'internalBusinessWallet':
              return 'BUSINESS'
            case 'internalRecurrentAddress':
              return 'RECURRENT'
            default:
              return 'COLLECT'
          }
        },
        addressCurrency({ selectedAddress = {} }) {
          return selectedAddress.currency
        },
        setAddress: {
          get({ selectedAddress }) {
            return selectedAddress
          },
          set(v) {
            this.selectedAddress = v
          }
        },
        usdRate({ selectedAddress = {} }) {
          return selectedAddress.usdRate
        },


        balanceType() {
            if (this.addressId && !this.account.availableCurrenciesForDeposit.some((i) => i === this.balanceCurrencyId)) {
                return this.$options.balanceType.filter((i) => i.value === 'PAY_OUT');
            }
            return this.$options.balanceType;

        },
        withdrawalCreated() {
            return !this._withdrawalPending && this._withdrawalComplete;
        },
        withdrawalCreating() {
            return this._withdrawalPending;
        },

        fetchingFee() {
            return this._feePending;
        },
        fetchedSuccessFee() {
            return !this.fetchingFee && this._feeComplete && this._feeCode === 0;
        },
        fetchedFailFee() {
            return !this.fetchingFee && this._feeComplete && this._feeCode !== 0;
        },

        feeSourceTitle() {
            if (this._feeSource === FEE_TOKEN_SOURCE.ADVANCED_BALANCE) {
                return this.$t('payout-modal-transfer.advance_balance')
            } else if (this._feeSource === FEE_TOKEN_SOURCE.WALLET) {
                return this.$t('payout-modal-transfer.address_balance')
            }

            return '';
        },
        feeAmount() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return Number(this._feeAmount);
        },
        feeUSD() {
            if (!this.fetchedSuccessFee) {
                return '0';
            }

            return this._feeUSD;
        },
        feeTariff({ _tariffFee }) {
          return _tariffFee || 0
        },
        feeNetwork({ _networkFee }) {
          return _networkFee || 0
        },
        feeCurrency() {
            if (!this.fetchedSuccessFee) {
                return '';
            }

            return this._feeCurrency;
        },
        feeAvailableSeconds() {
            const now = moment(this.time);
            const until = moment(this._feeUntil);

            const delta = until.diff(now, 'seconds');

            if (delta > 0) {
                return delta;
            }

            if (delta <= -1) {
                return -1;
            }

            return 0;
        },

        account() {
            return this.accounts.find(a => a.accountId === this.accountId);
        },
        accountCurrency() {
            return this.currencies.find(c => c.id === this.account?.currencyId);
        },
        accountBalance() {
            return this.account?.balance || '0';
        },
        accountBalanceAfter() {
            const advanceBalance = this.account?.balance || '0'

            return new BigNumber((Number(advanceBalance) - Number(this._tariffFee) - Number(this._networkFee)) + Number(this.amount) || '0')
              .dp(8, BigNumber.ROUND_HALF_UP)
              .toNumber();
        },

        accountCurrencyId() {
            return this.accountCurrency?.id;
        },
        balance() {
            return this.addressesList.find(a => a.id === this.addressId);
        },
        balanceCurrency() {
            return this.currencies.find(c => c.id === this.balance?.currencyId);
        },
        balanceAmount() {
            return Number(this.balance?.balance || '0');
        },
        balanceNetwork() {
            return this.balanceCurrency?.networks.find(n => n.id === this.balance.networkId);
        },

        balanceCurrencyId() {
            return this.balanceCurrency?.id;
        },
        balanceNetworkId() {
            return this.balanceNetwork?.id;
        },

        hasTag() {
            return this.balance?.tagRegex;
        },

        balanceValid() {
            if (this._feeSource === FEE_TOKEN_SOURCE.ADVANCED_BALANCE) {
                return new BigNumber(this.accountBalance).gte(this.feeAmount);
            }

            return true;
        },
        addressValid() {
            if (this.addressId) {
                if (this.balanceCurrency?.currency === "BCH") {
                    return bchaddr.isValidAddress(this.address);
                }
            }

            return this.balanceNetwork && this.balanceNetwork.addressRegex && new RegExp(this.balanceNetwork.addressRegex).test(this.address);
        },
        tagValid() {
            return this.balanceNetwork && this.balanceNetwork.tagRegex && new RegExp(this.balanceNetwork.tagRegex).test(this.tag);
        },
        amountValid() {
            if (new BigNumber(this.balanceAmount).lt(this.balanceNetwork?.minWithdrawal)) {
                return false;
            }

            if (new BigNumber(this.amount).lt(this.balanceNetwork?.minWithdrawal)) {
                return false;
            }

            if (new BigNumber(this.amount).gt(this.balanceAmount)) {
                return false;
            }

            return true;
        },

        minWithdrawal() {
            return this.balanceNetwork?.minWithdrawal || 0;
        },

        amountToReceive() {
            if (this._feeSource === 'wallet') {
                const amount = new BigNumber(this.amount || '0').minus(Number(this._tariffFee) + Number(this._networkFeeUSD))
                    .dp(8, BigNumber.ROUND_HALF_UP);

                if (amount.lte(0)) {
                    return 0;
                }

                return amount.toNumber();
            }

            return new BigNumber(this.amount || '0')
                .dp(8, BigNumber.ROUND_HALF_UP)
                .toNumber();
        },
        amountToReceiveUSD({ amountToReceive, usdRate }) {
          return new BigNumber(amountToReceive * usdRate || '0')
              .dp(8, BigNumber.ROUND_HALF_UP)
              .toNumber();
        },
        actionButtonDisabled() {
            if (!this.addressId) {
                return true;
            }

            if (this.fetchingFee) {
                return true;
            }

            if (!this.balanceValid && this.addressTo !== 'ADVANCE') {
                return true;
            }

            if (new BigNumber(this.amountToReceive).lte(0)) {
                return true;
            }

            if (this.feeAvailableSeconds <= 0) {
                return true;
            }

            if (this.tag && !this.tagValid) {
                return true;
            }

            if (!this.amountValid) {
                return true;
            }

            return false;
        },
        actionButtonTitle() {
            return this.$t('payout-modal-transfer.send');
        },

        isOpen() {
            const {
                $options: {name},
                isOpenModal,
            } = this;

            return isOpenModal(name);
        },
        title() {
            return this.$t('advance_balances.transfer');
        },
        hasErrors() {
            return Boolean(this.errors.length);
        },
        creating_an_application() {
            return this.$t('payout-modal-transfer.creating_an_application');
        },
        select_address() {
            return this.$t('payout-modal-transfer.select_address');
        },
        enter_address() {
            return this.$t('payout-modal-transfer.enter_address');
        },
        enter_tag() {
            return this.$t('payout-modal-transfer.enter_tag');
        },
        enter_amount() {
            return this.$t('payout-modal-transfer.enter_amount');
        },
        showMinWithdrawalTip() {
            return this.minWithdrawal !== 0;
        },
        getCurrencyImageForSelect() {
            if (this.addressId) return this.addressesList.find((i) => i.id === this.addressId).currencyId;
            return '';
        },
        getNetworkIdForSelect() {
            if (this.addressId) return this.addressesList.find((i) => i.id === this.addressId).networkId;
            return '';
        },
        getSelectedAddress() {
            if (this.addressId) return this.addressesList.find((i) => i.id === this.addressId);
            return null;
        },
        getCurrencyName() {
            if (this.getCurrencyImageForSelect) return this.currencies.find((i) => i.id === this.getCurrencyImageForSelect);
            return '';
        },
    },
    methods: {
        ...mapMutations('payoutBalances', ['clearDepositData', 'clearFee', 'setFeePending']),
        ...mapActions('app', [
            'closeModal',
        ]),
        ...mapActions('accounts', [
            'getAllNetworks',
        ]),
        ...mapActions('balances', [
            'getAccountBalancesPayin',
            'getAccountBalancesBusiness',
            'getAccountBalancesRecurrent',
            'getAccountBalancesGrouped',
            'getAccountBalancesCollect',
            'getPrice',
        ]),
        ...mapActions('payoutBalances', [
            'makeTransferRequestMutation',
            'fetchFeeForTransfer',
        ]),
        shortNetworkName( network ) {

          let shortFromFullName = network.match(/\((.+?)\)/)

          if (!shortFromFullName) {
            if (network === 'Fantom') {
              shortFromFullName = "FTM"
            } else if (network === 'Solana') {
              shortFromFullName = "SOL"
            } else {
              shortFromFullName = network
            }
          } else {
            shortFromFullName = shortFromFullName[1]
          }

          return shortFromFullName
        },
        async getAddressesList() {
          const { accountId, depositMethodLink } = this

          let balances = await this[depositMethodLink]({ accountId })

          // фильруем по наличию баланса и пересобираем балансы в том виде который нам нужен
          balances = balances
              .filter( b => !!b.balance && !!Number(b.balance) )
              .map(b => {
                const currency = this.currencies.find(({ id }) => id === b.currencyId)
                const network = currency.networks.find(({ id }) => id === b.networkId)

                return {
                  id: b.id,
                  address: b.address,
                  allowPayout: currency.allowPayout,
                  balance: b.balance,
                  currencyId: b.currencyId,
                  currency: currency.currency,
                  currencyAlias: currency.alias,
                  usdRate: currency.usdRate,
                  networkId: b.networkId,
                  networkName: network.name,
                  networkAlias: network.alias,
                  networkShortName: this.shortNetworkName(network.alias)
                }
              })
              .filter((b) => b.allowPayout)

          if (this.addressTo === 'ADVANCE') {
            return balances = balances.filter((b) => this.account.availableCurrenciesForDeposit.some(c => c === b.currencyId));
          }

          return balances
        },
        maxAmount() {
            this.amount = this.balance.balance;
        },
        clearAllData() {
            this.selectedAddress = undefined
            this.accountId = ''
            this.address = ''
            this.addressTo = 'ADVANCE'
            this.tag = ''
            this.amount = null
            this.clearFee()
            this.clearDepositData()
        },
        handleCancelCreate() {
            const {
                clearAllData,
                closeModal,
            } = this;
            closeModal();
            if (this.withdrawalCreated) this.getAccountBalancesGrouped({accountId: this.accountId});
            clearAllData();
        },
        startTimer() {
            if (this.timerId) {
                return;
            }

            this.timerId = setInterval(() => {
                this.time = new Date().toJSON();
            }, 1000);
        },
        stopTimer() {
            clearInterval(this.timerId);
            this.timerId = 0;
        },

        fetchFee() {
            if (!(this.addressId && this.accountId && this.amount)) {
                return;
            }

            this.clearFee();
            this.fetchFeeForTransfer({
                accountId: this.accountId,
                addressId: this.addressId,
                amount: this.amount ? this.amount.toString() : '0',
            });
        },
        async getFeeForTransferInputWrap() {
            if (!(this.addressId && this.accountId && this.amount)) {
                return;
            }
            this.clearFee();
            this.isFeeDebouncing = true;
            if (this.addressId) {
                await this.getFeeForTransferInput();
            }
        },
        getFeeForTransferInput: _.debounce(function () {
            this.fetchFeeForTransfer({
                accountId: this.accountId,
                addressId: this.addressId,
                amount: this.amount ? this.amount.toString() : '0',
            }).finally(() => {
                this.isFeeDebouncing = false;
            });
        }, 1000),

        createWithdrawal() {
            if (this._withdrawalPending) {
                return;
            }

            const payload = {
                accountId: this.accountId,
                addressId: this.addressId,
                from: this.addressFrom,
                to: this.addressTo,
                amount: new BigNumber(this.amount)
                    .toFixed(8, BigNumber.ROUND_HALF_DOWN),
                feeToken: this._feeToken,
            };

            this.makeTransferRequestMutation(payload);
        },

        setMaxAmount() {
            if (!(this.addressId && this.accountId)) {
                return;
            }

            this.amount = this.balanceAmount
        },
    },
    watch: {
        withdrawalCreated(n, o) {
            if (!(typeof n !== "undefined" && typeof o !== "undefined")) {
                return;
            }

            if (n === o) {
                return;
            }

            if (!n) {
                return;
            }
        },
        async isOpen(status) {
            if (!status) {
                this.clearAllData();
                this.stopTimer();

                return;
            }

            this.startTimer();

            if (this.accounts.length) {
                this.accountId = this.accounts[0].accountId;
            }

            this.addressesList = await this.getAddressesList()
        },
        accounts() {
            if (this.accounts.length) {
                this.accountId = this.accounts[0].accountId;
            }
        },
        _withdrawalError(message) {
            if (!message) {
                return;
            }
            console.error(message);
            this.$Message.error(this.$t(message));
        },
        addressId(n, o) {
            if (!n) {
                return;
            }

            if (n === o) {
                return;
            }
            if (this.isFeeDebouncing === null) {
                this.isFeeDebouncing = false;
            }

            this.amount = ''
            this.fetchFee();
        }
    },
};
</script>
<style lang="scss">
.payout-modal-transfer {
  font-family: var(--new-front-font-family);

  &__header {
    text-align: center;

    .title {
      font-size: $h1;
      color: var(--new-front-text-primary-bg-modal-primary);
      font-weight: 500;
    }

    .subtitle {
      font-size: $h4;
      color: var(--new-front-text-secondary-bg-modal-primary);
    }
  }
  &__body {
    padding: 0 20px;
    margin-bottom: 30px;

    .result {
      //$h1: 32px;
      //$h2: 24px;
      //$h3: 20px;
      //$h4: 16px;
      //$h5: 14px;
      //$h6: 13px;
      //$h7: 12px;
      //$h8: 10px;
      &__message-title {
        font-size: $h1;
        font-style: normal;
        font-weight: 500;

        text-align: center;

        color: var(--new-front-text-primary-bg-modal-primary);
      }
      &__message-subtitle {
        font-size: $h4;
        font-style: normal;
        font-weight: 500;

        text-align: center;

        margin-top: 10px;

        color: var(--new-front-text-secondary-bg-modal-primary);
      }
    }

    .amount-input {
      margin: 10px 0;

      .label-left {
        color: var(--new-front-text-tertiary-bg-modal-primary)!important;
        font-size: $h6;
      }
    }
    .title-special {}
    .fee-loader {
      padding-top: 40px;
    }
    .info-container {
      margin-top: 20px;
      font-weight: 500;

      &.disabled {
        .info-container__row {
          border-top: 1px dashed var(--new-front-border-color-disabled);
          .first-line {
            color: var(--new-front-text-disabled-bg-modal-primary);
            .value {
              .grey {
                color: var(--new-front-text-disabled-bg-modal-primary);
              }
            }
          }
          .second-line {
            color: var(--new-front-text-disabled-bg-modal-primary);
          }
        }
      }

      &__row {
        width: 100%;

        font-size: $h4;

        border-top: 1px dashed var(--new-front-stroke-modal-bg-primary);

        padding: 10px 0;

        .first-line {
          display: flex;
          align-items: center;

          color: var(--new-front-text-primary-bg-modal-primary);

          padding: 5px 0;

          .label {
            width: 100%;
            text-align: left;
          }
          .value {
            text-align: right;
            white-space: nowrap;

            .grey {
              color: var(--new-front-text-tertiary-bg-modal-primary);
            }
          }
        }
        .second-line {
          display: flex;
          align-items: center;

          color: var(--new-front-text-tertiary-bg-modal-primary);

          padding: 5px 0;

          .label {
            width: 100%;
            text-align: left;
          }
          .value {
            text-align: right;
            white-space: nowrap;
          }
        }

        &.first {
          border-top: none;
        }
      }
    }
  }
  &__footer {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    .base-btn {
      max-width: 280px;
      min-width: 260px;

      &.secondary {
        .update-btn-label {
          display: flex;
          align-items: center;

          svg {
            margin-right: 7px;
          }

          font-family: var(--new-front-font-family);

          color: var(--new-front-btn-bg-secondary-text);

          font-style: normal;
          font-weight: 500;
          font-size: $h4;

          padding: 0 10px;

          white-space: nowrap;

          @include below_phone() {
            font-size: $h5;
          }
        }

        &.disabled {
          .label {
            //color: var(--new-front-btn-bg-primary-disabled-text);
          }
        }
      }
    }

    &.withdrawal-created {
      .base-btn {
        min-width: 100%;
        max-width: 100%;
      }
    }
  }

  @include below_phone(){
    &__header {
      .title {
        font-size: $h3;
        margin-bottom: 0;
        font-width: 500;
      }
      .subtitle {
        font-size: $h6;
      }
    }
    &__body {
      margin-bottom: 0;

      .info-container {
        .info-container__row {
          padding: 5px 0;

          .first-line {
            font-size: $h6;
          }
          .second-line {
            font-size: $h6;
          }
        }
      }
    }
    &__footer {
      justify-content: center;
      flex-wrap: wrap;

      .base-btn {
        margin-top: 10px;
        min-width: 100%;
        max-width: 100%;
      }

      &.withdrawal-created {
        .base-btn {
          margin-top: 0;
        }
      }
    }
  }
}
</style>
